module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f46504a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/gmap-vue/dist/components/info-window.vue
// module id = 1482
// module chunks = 0